import InputField from "../InputField/InputField";
import styles from "./LoginComponent.module.scss";
import { useNavigate, useLocation } from "react-router-dom";
import UserName from "application/images/username.png";
import Password from "application/images/passwordicon.png";
import Button from "../Button/Button";
import { useEffect, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
import api from "application/utilities/axiosIntance";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { Result } from "application/types/GetLoginDetails";
import { renderLinkOrSpan } from "../SupportText/SupportText";
import RegionSelector from "./RegionSelector";
import { useTranslation } from 'react-i18next';
import { useCookiebotManager } from 'application/utilities/useCookiebotManager';

const LoginComponent = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [pageLoader, setPageLoader] = useState(true);
    const [loginData, setLoginData] = useState<{ loginTKF: string; loginURL: string; portalHome: string } | null>(null);
    const formRef = useRef<HTMLFormElement | null>(null);
    const navigate = useNavigate();
    const region = useSelector((state: RootState) => state.region.region);
    const location = useLocation();
    const { t, i18n } = useTranslation();
 
    useCookiebotManager(region);
    const layoutState = useSelector((state: RootState) => state.layout) as {
        data: Result;
        isLoading: boolean;
        error: string | null;
    };
    const { data, isLoading } = layoutState;
 
    const regionLoading = useSelector((state: RootState) => state.region.isLoading);

    useEffect(() => {
        setPageLoader(isLoading || regionLoading);
    }, [isLoading, regionLoading]);

    useEffect(() => {
        if (loginData && formRef.current) {
            formRef.current.submit();
        }
    }, [loginData]);

    useEffect(() => {
        setUsername("");
        setPassword("");
        setErrorMessage("");
    }, [location.key]);

    useEffect(() => {
        i18n.changeLanguage(region.toLowerCase());
    }, [region,i18n]);

    const handleLogin = () => {
        setErrorMessage("");
        setLoading(true);

        const errors: string[] = [];
        if (!username.trim()) errors.push(t("FIELD_NAME_USERNAME"));
        if (!password.trim()) errors.push(t("FIELD_NAME_PASSWORD"));

        if (errors.length > 0) {
            const last = errors.pop();
            const fields = errors.join(", ");
            const message = errors.length            
                ? t("FIELD_REQUIRED_MULTIPLE", { fields, last })
                : t("FIELD_REQUIRED_SINGLE", { field: last })            
            setErrorMessage(message.charAt(0).toUpperCase() + message.slice(1));
            setLoading(false);
            return;
        }

        const authHeader = `Basic ${btoa(`${username}:${password}`)}`;

        api
            .post("/Login/Login", {
                regionCode: region,
                systemType: "",
            },
        {
            headers: {
                 Authorization: authHeader,
            }
        })
            .then((response) => {
                const { isSuccess, result } = response.data;
                if (!isSuccess) {
                    setErrorMessage(t("GENERIC_LOGGING_ERROR"));
                    setLoading(false);
                    return;
                }
                if (result.loginSuccess) {
                    if (!result.isBrowserSupported) {
                        navigate("/browser-compatibility");
                        setLoading(false);
                        return;
                    }

                    const formattedLoginURL = result.loginURL.startsWith("//")
                        ? `https:${result.loginURL}`
                        : result.loginURL;

                    setLoginData({
                        loginTKF: result.loginTKF,
                        loginURL: formattedLoginURL,
                        portalHome: result.portalHome
                    });
                    return;
                }
                setErrorMessage(result.errorMessage);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Login error:", error);
                setErrorMessage(t("GENERIC_LOGGING_ERROR"));
                setLoading(false);
            });
    };

    const handleRegionChange = (region: { regionCode: string; regionName: string }) => {
        i18n.changeLanguage(region.regionCode.toLowerCase());
        setErrorMessage("");
        setUsername("");
        setPassword("");
    };

    if (pageLoader) {
        return <Spinner animation="border" className={styles.spinner}/>;
    }

    const middleLinks = data?.middleLinks || [];

 
    return (
        <div className="d-flex justify-content-center align-items-center w-100 mb-2">
            <nav className={`${styles.popup} px-5 py-2`}>
              
                <RegionSelector onRegionSelect={handleRegionChange} />
                {errorMessage && (
                    <div className={`${styles.error} d-flex align-items-center justify-content-center text-center pt-2`}>
                        {errorMessage}
                    </div>
                )}

                <form onSubmit={(e) => e.preventDefault()}>
                    <InputField
                        id="username"
                        icon={UserName}
                        placeholder={t('LOG_IN_USERNAME')}
                        value={username}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setUsername(e.target.value)}
                        autoFocus
                    />
                    <InputField
                        id="userpassword"
                        icon={Password}
                        placeholder={t('LOG_IN_PASSWORD', { defaultValue: t('FIELD_NAME_PASSWORD') })}
                        type="password"
                        value={password}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                    />
                    <Button id="login" type="submit" label={t('LOG_IN')} onClick={handleLogin} loading={loading} />
                </form>

                <div className="mt-3 mb-2">
                    <div className={`d-flex justify-content-center align-items-center flex-wrap gap-1 ${styles.helpText}`}>
                         <span style={{ whiteSpace: 'nowrap' }}>
                     
                        {middleLinks[0] && renderLinkOrSpan(middleLinks[0], `mx-1 ${styles.details}`)}
                        </span>
                        
                    </div>
                    <div className={`justify-content-center mt-2 text-center ${styles.helpText}`}>
                        {middleLinks[1] && renderLinkOrSpan(middleLinks[1], "")}
                        {middleLinks[2] && renderLinkOrSpan(middleLinks[2], styles.details, "", true)}
                    </div>
                </div>
            </nav>

            {loginData && (
                <form
                    ref={formRef}
                    method="POST"
                    action={loginData.loginURL}
                    target="_top"
                    style={{ display: "none" }}
                >
                    <input type="hidden" name="LoginTKF" value={loginData.loginTKF} />
                    <input type="hidden" name="portal" value={loginData.portalHome} />
                </form>
            )}
        </div>
    );
};

export default LoginComponent;

